/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { Images } from "@packages/sdk";

import type { ThemeType } from "../../../../../../global/emotion";
import {
  numericPercentages,
  radius,
  spacing,
} from "../../../../../../global/emotion";
import { HallowImage } from "../../../../blocks/other/HallowImage/HallowImage";
import { Text } from "../../../_core/Text/Text.emotion";
import { VideoIcon } from "../../../icons/Icon/GeneralIcons";
import { InlineIcon } from "../../../icons/Icon/Icon";

type ContentMoreMenuHeaderProps = {
  imageSrc?: Images;
  title: string;
  subtitle: string;
  metadata: string;
  hasVideoContent: boolean;
};

const containerStyle: Interpolation = {
  display: "flex",
  gap: spacing.ms,
  maxWidth: numericPercentages[100],
  paddingInline: spacing.m,
};
const textContainerStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.xs,
  maxWidth: `calc(100% - 72px - ${spacing.ms})`,
};
const imageStyle: Interpolation<ThemeType> = (theme) => ({
  backgroundColor: theme.semanticColors.neutralsMedium,
  borderRadius: radius.s,
  flexShrink: 0,
  objectFit: "cover",
  objectPosition: "center",
  objectRepeat: "no-repeat",
});
const metadataStyle: Interpolation = {
  alignItems: "center",
  columnGap: spacing.xs,
  display: "inline-flex",
};

const ContentMoreMenuHeader = ({
  title,
  subtitle,
  metadata,
  imageSrc,
  hasVideoContent,
}: ContentMoreMenuHeaderProps) => {
  return (
    <div css={containerStyle}>
      <HallowImage
        src={imageSrc}
        size={"s"}
        alt={title}
        width={72}
        height={72}
        css={imageStyle}
      />
      <div css={textContainerStyle}>
        <Text type="title" size="m" overflow="ellipsis" title={title}>
          {title}
        </Text>
        <Text type="body" size="s" overflow="ellipsis" title={subtitle}>
          {subtitle}
        </Text>
        <Text
          type="detail"
          size="l"
          overflow="ellipsis"
          title={metadata}
          css={metadataStyle}
        >
          {hasVideoContent ? <InlineIcon icon={<VideoIcon.Filled />} /> : null}
          {metadata}
        </Text>
      </div>
    </div>
  );
};

export default ContentMoreMenuHeader;
